export type Dimension = {
  name: string;
  score: number;
  rationale: string;
  evidence: string[];
};

export type SlopResult = {
  url: string;
  overallScore: number;
  band: string;
  aiFeelVerdict: string;
  summary: string;
  contentLevel: 1 | 2 | 3;
  contentLevelLabel: string;
  contentLevelExplanation: string;
  dimensions: Dimension[];
  topFixes: string[];
  cached?: boolean;
};

export type SlopErrorCode = "RATE_LIMIT" | "UNREADABLE" | "INVALID_URL" | "GRADING_FAILED";

export class SlopApiError extends Error {
  code: SlopErrorCode;
  constructor(code: SlopErrorCode, message: string) {
    super(message);
    this.code = code;
  }
}

export type Lead = {
  id: string;
  url: string;
  email: string | null;
  submittedAt: string | null;
  overallScore: number;
  band: string;
  notes: string;
  contacted: boolean;
};
